// src/config/wsBotConnectionConfig.js (NEW FILE)

export const WS_BOT_CONNECTION_TYPES = {
  // Client -> Server
  CONNECT_SERVER: 'BOT_CONNECT_SERVER',
  DISCONNECT_SERVER: 'BOT_DISCONNECT_SERVER',
  DEPLOY_BOT: 'BOT_DEPLOY',
  STOP_DEPLOYMENT: 'BOT_STOP_DEPLOYMENT',
  GET_STATE: 'BOT_GET_STATE',
  GET_HISTORY: 'BOT_GET_HISTORY', // New
  INTERACT_CAPTCHA: 'BOT_INTERACT_CAPTCHA',
  CONTROL: 'BOT_CONTROL',
  LOOK: 'BOT_LOOK',
  GUI_CLICK: 'BOT_GUI_CLICK',
  GUI_CLOSE: 'BOT_GUI_CLOSE',
  GUI_OPEN_MENU: 'BOT_GUI_OPEN_MENU',

  // Server -> Client (via user-specific queue)
  CONNECTION_STATUS: 'BOT_CONNECTION_STATUS',
  DEPLOYMENT_STARTED: 'BOT_DEPLOYMENT_STARTED',
  DEPLOYMENT_PROGRESS: 'BOT_DEPLOYMENT_PROGRESS',
  DEPLOYMENT_COMPLETED: 'BOT_DEPLOYMENT_COMPLETED',
  CONSOLE_LINE: 'BOT_CONSOLE_LINE',
  CURRENT_STATE: 'BOT_CURRENT_STATE',
  ERROR: 'BOT_ERROR',
  HISTORY_LIST: 'BOT_HISTORY_LIST', // New
  HISTORY_ERROR: 'BOT_HISTORY_ERROR', // New
  CAPTCHA_REQUIRED: 'BOT_CAPTCHA_REQUIRED',
  GUI_WINDOW_OPEN: 'BOT_GUI_WINDOW_OPEN',
  GUI_WINDOW_CLOSE: 'BOT_GUI_WINDOW_CLOSE',
  VIEWER_READY: 'BOT_VIEWER_READY',
};

export const WS_BOT_CONNECTION_TOPICS = {
  USER_QUEUE_BASE: '/user/queue/bots',
  STATUS: '/status',
  PROGRESS: '/progress',
  ERROR: '/error',
  USER_HISTORY: '/history', // New user queue topic
  USER_GUI: '/gui',

  APP_ENDPOINT: '/bots',
  APP_GET_HISTORY: '/get-history', // New app endpoint path
  APP_CONTROL: '/control',
  APP_LOOK: '/look',
  APP_GUI_CLICK: '/gui/click',
  APP_GUI_CLOSE: '/gui/close',
  APP_GUI_OPEN_MENU: '/gui/open-menu',
};
// Helper function (add if needed, or use base + topic directly)
export const getBotAppEndpoint = (action) => `${WS_BOT_CONNECTION_TOPICS.APP_ENDPOINT}${action}`;
export const getBotUserQueueTopic = (subTopic) => `${WS_BOT_CONNECTION_TOPICS.USER_QUEUE_BASE}${subTopic}`;